import React from "react";
import Container from "@mui/material/Container";
import Stack from "components/common/Stack";
import Text from "components/common/Text";

const HubPlaceholderContainer = ({ title, message }) => (
  <Container maxWidth="md" sx={{ px: { xs: 2, md: 4 }, py: 8 }}>
    <Stack spacing={2} alignItems="center" textAlign="center">
      <Text variant="h5" sx={{ fontWeight: 600, color: "#111827" }}>
        {title}
      </Text>
      <Text variant="body1" sx={{ color: "#676E76", maxWidth: 420 }}>
        {message}
      </Text>
    </Stack>
  </Container>
);

export default HubPlaceholderContainer;
